import { ISystemContext } from "./Context/SystemContext";
import { GameSession } from "./GameSession";
import { CreateElement, Log, LogGroup, Scale, Size } from "./MyHelpers";
//import { IHistoryEntry } from "./menu/MenuPages/GameHistoryPage";
import { GameTitleJackpot3S } from "./3DisplayFactory/GameTitleJackpot3S";
import { IScreen3DisplayFactory, Screen3DisplayFactory, Screen3DisplayParams } from "./3DisplayFactory/Screen3DisplayFactory";
import { CreateGameFactory, IGameFactory } from "./GameFactoy";
import { IJackpotDisplay } from "./IJackpotDisplay";
import { IJackpotDisplayFactory } from "./IJackpotDisplayFactory";
import { IMultigame } from "./IMultigame";
import { Button } from "./IO";
import { JackpotDisplayFactory } from "./JackpotDisplayFactory";
import { JackpotDisplayParams } from "./JackpotDisplayParams";
import { MultigameGamesLoadedCallback, MultigameResourcesLoadedCallback } from "./Multigame";
import { AvailableGame } from "./MultigameAvailableGame";
import { MultigameParams3 } from "./MultigameParams3";
import { CSSResource } from "./ResourceManager/CSSResource";
import { FontResource } from "./ResourceManager/FontResource";
import { HTMLResource } from "./ResourceManager/HTMLResource";
import { JSResource } from "./ResourceManager/JSResource";
import { ResourceIdentifier } from "./ResourceManager/ResourceIdentifier";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager, LoadingStage, ResourceManager } from "./ResourceManager/ResourceManager";
import { AnimationStartRequest, AnimationStopRequest, JackpotValuesUpdate2, OtherScreen, ScreenGameMenuMessage, ScreenGameSelectedMessage, ScreenIntroductionMessage, ScreenMultigameSyncMessage, ScreenProtocol, ScreenReloadMessage } from "./ScreenProtocol";
import { JackpotDisplayType, MenuType, Screen3SettingDisplay, ScreenConfiguration, Settings } from "./Settings";
import { SlotGameInitData } from "./SlotGameInitData";
import { ZIndex } from "./ZIndex";
import { GameType, IGameConfiguration, JackpotValue2, LoadInfo, SettingsNode } from "./api";
import { BackendSettings, IBackendSettings } from "./help/Help";
import { IGamesMenu } from "./menu/IGamesMenu";
import { IGamesMenuParams } from "./menu/MenuFactory";
import { GamesMenu3ScreenFactory, IGamesMenu3ScreenFactory } from "./menu/MenuFactory3";
import { service } from "./services";
import { SlotGame3 } from "./slot/SlotGame3";
import { StateMachine } from "./slot/StateMachine";
import { Resource } from "./ResourceManager/Resource";
import { MultigameParams21 } from "./MultigameParams21";
import { SlotGame21 } from "./slot/SlotGame21";
import { AudioManager } from "./AudioManager";
import { ImageResource } from "./ResourceManager/ImageResource";
import { PixiSpriteResource } from "./ResourceManager/PixiSpriteResource";
import { IGamePresentation } from "./IPresentation";
import { CanvasSprite, CanvasSpriteSizing } from "./slot/Sprite/CanvasSprite";
import { ISprite } from "./slot/Sprite/ISprite";
import { SlotGame } from "./slot/SlotGame";
import { IInterval } from "./Context/Interval";
import { SpriteResource } from "./ResourceManager/SpriteResource";
import { Orientation } from "./FitScreen";
//import { CashierLogin } from "./menu/CashierLogin";
namespace SlotGames3 {
}

export class GamePresentation21 implements IGamePresentation
{
	protected title: CanvasSprite = null;


	protected titleRepeatDelay: number = -1;

	constructor(title: CanvasSprite)
	{
		this.title = title;
	
		this.title.AddOnCompleteCallback(() => {
			if (this.titleRepeatDelay != -1)
			{
				clearTimeout(this.titleRepeatDelay);
				this.titleRepeatDelay = -1;
			}

			this.titleRepeatDelay = window.setTimeout(() => {
				this.title.Start(false);
				this.titleRepeatDelay = -1;
			}, Math.random() * 2000 + 4000);
		});
	}

	public Show()
	{
		this.title.Restart(false);
		this.title.View().style.visibility = "visible";
		
	}

	public Hide()
	{
		this.title.Stop();
		this.title.View().style.visibility = "hidden";

		if (this.titleRepeatDelay != -1)
		{
			clearInterval(this.titleRepeatDelay);
			this.titleRepeatDelay = -1;
		}
	}

	public Update()
	{
		this.title.Update();
	}
	
}
export class Multigame21Session extends GameSession
{
	public selectedGameNameInMenu: string = null;
	public selectedGameName: string = null;

	public constructor() {
		super();
	}
}


export enum Multigame21State
{
	Idle,
	Loading,
	Running
}

// seconds screen of multigame
export class Multigame21 implements IMultigame
{
	protected systemContext: ISystemContext = null;

	//se agrego esto para el contenedor del JP
	// protected jackpot2: string = null;
	// protected jackpotContainer2: HTMLElement = null;

	protected screenProtocol: ScreenProtocol = null;

	private multigameParams: MultigameParams21 = null;

	// only basic game info
	protected availableGames: Map<string, AvailableGame> = new Map<string, AvailableGame>();

	// initial data for constructing games
	protected initData: Map<string, SlotGameInitData> = new Map<string, SlotGameInitData>();

	// complete games, by name
	protected slotGames: Map<string, SlotGame21> = new Map<string, SlotGame21>();

	// complete games, by index
	//protected slotGamesByIndex: Map<number, SlotGame3> = new Map<number, SlotGame3>();
	

	protected screenName: string = "21";
	protected viewSize: Size = null;
	protected view: HTMLElement = null;
	//protected multigameView: HTMLElement = null;

	protected resizeFitTimer: number = -1;
	protected resizeFitDelay: number = 200;

	protected gamesContainer: HTMLElement = null;
	protected gamesMenuContainer: HTMLElement = null;
    protected loadingContainer: HTMLElement = null;

	protected logGroup: LogGroup = new LogGroup("Multigame21");

	protected screenProtocolScope = "multigame";
	protected resourceManager: ResourceManager = null;
	protected backendSettings: BackendSettings;
	//protected cashierLogin: CashierLogin;
	// resources
	protected resid: ResourceIdentifier = null;
	protected basepath: string = Settings.ResourcesFolder + "multigame/multigame/";
	//se agrego esto para el contenedor del JP
	//protected jackpot2: string = Settings.ResourcesFolder + "multigame/multigame/img/";
	//protected jackpotContainer2: HTMLElement = null;

	protected gamesLoaded: number = 0;


	// currently selected game
	//protected selectedGameInMenuIndex: number = 0;
	//protected selectedGameIndex: number = 0;
	protected session: Multigame21Session = new Multigame21Session();
	// new session data to be set
	protected tmpSession: Multigame21Session = null;
	protected selectedGame: SlotGame21 = null;

	protected stateMachine: StateMachine<Multigame21State> = null;

	//protected jackpotDisplay: JackpotDisplayOrtiz= null;
	protected jackpotDisplay: IJackpotDisplay = null;

	//ADD TRANSLATOR 
	//public translator: Translator = null;

	protected JackpotDisplayFactory: IJackpotDisplayFactory = new JackpotDisplayFactory();
	private gamesMenu21: IGamesMenu = null;
	public menuFactory3 : IGamesMenu3ScreenFactory = new GamesMenu3ScreenFactory();

	protected screen3DisplayFactory : IScreen3DisplayFactory = new Screen3DisplayFactory();
	// protected screen3Display : GameTitleJackpot3S = null;
	protected serialNumber: string = "---";
	protected audio: AudioManager;

	protected UpdateSerialNumber()
	{
		if (this.serialNumberElement)
			this.serialNumberElement.innerHTML = this.serialNumber;
	}
	protected divtitle: HTMLElement;
	protected div: HTMLElement;

	public constructor(systemContext: ISystemContext, audio: AudioManager) {

		this.systemContext = systemContext.CreateSubContext("Multigame");
		this.audio = audio;

	    void service.api.registerOperation("LinkLicence", "Multigame3/OnLinkLicence", data => {
			this.serialNumber = data.LinkLicenceStatus?.LinkLicence?.Hardware?.IOSerial ?? "";
			this.UpdateSerialNumber();
		});

		this.viewSize = new Size(Settings.ScreenWidth, Settings.ScreenHeight);

		this.resid = new ResourceIdentifier("Screen21", "Multigame");
		this.stateMachine = new StateMachine<Multigame21State>(Multigame21State.Idle, this.logGroup, (s) => Multigame21State[s]);

		this.view = document.createElement("div");
		this.view.classList.add("Multigame-21-"+this.resid.Scope());
		this.view.style.position = "relative";
		this.view.style.width = this.viewSize.Width + "px";
		this.view.style.height = this.viewSize.Height + "px";
		this.view.style.zIndex = ZIndex.ElementsMenu.toString();
		//this.view.style.margin = "-1px 0px";
		//this.view.style.border = "1px solid red";

        this.loadingContainer = CreateElement("div", {
			classes: ["loading"],
			parentToAppend: this.view,
			style: {
				display: "flex",
				position: "absolute",
				width: "100%",
				height: "100%",
				justifyContent: "center",
				alignItems: "center",
				zIndex: ZIndex.LoadingContainer.toString(),
				color: "white",
				fontSize: Scale.fhpx(100),
			},
			innerHTML: "Loading..."
		});

		this.divtitle=CreateElement("div", {
			id: "title",

			style: {
				top: Scale.Ypx(310),
				width: "100%",
				height: Scale.Hpx(410),
				position: "absolute",
				left: "0px",
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
				backgroundPosition: "center",
				backgroundSize: "contain",
				zIndex : ZIndex.ElementsMenu.toString(),
			}
		});

		this.div=CreateElement("div", {
			classes: ["UnknownDiv"],
			style: {
				top: "200px",
				width: "100%",
				height: "100%",
				position: "absolute",
				left: "0px",
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
		}});

		this.screenProtocol = new ScreenProtocol(this.screenName);
		this.screenProtocol.SetKeepAlive(1000);
		this.screenProtocol.CheckAlive(new OtherScreen("1", 2500, 
			() => this.MainScreenConnectionLost(),
			() => this.MainScreenConnectionRestored()
		));

		//this.screenProtocol.AddReceiveMessageHandler(ScreenIntroductionMessage.msgname, (message) => this.OtherScreenIntroduction(<ScreenIntroductionMessage>message), this.screenProtocolScope);
		this.screenProtocol.AddReceiveMessageHandler(ScreenReloadMessage.msgname, (message) => this.MainScreenReloadRequest(), this.screenProtocolScope);
		// this.screenProtocol.AddReceiveMessageHandler(ScreenLoadInfoMessage.msgname, (message) => this.SetLoadInfo((<ScreenLoadInfoMessage>message).machineInfo), this.screenProtocolScope);
		//this.screenProtocol.AddReceiveMessageHandler(ScreenGameInitDataMessage.msgname, (message) => this.SetInitialData((<ScreenGameInitDataMessage>message).gameInitData), this.screenProtocolScope)
		// this.screenProtocol.AddReceiveMessageHandler(LoadInfoGames.msgname, (message) => this.LoadGames((message as LoadInfoGames).loadInfo), this.screenProtocolScope);
		this.screenProtocol.AddReceiveMessageHandler(ScreenMultigameSyncMessage.msgname, (message) => this.OnMultigameSync(<ScreenMultigameSyncMessage>message), this.screenProtocolScope);

		this.screenProtocol.AddReceiveMessageHandler(ScreenGameSelectedMessage.msgname, (message) => this.GameSelected((<ScreenGameSelectedMessage>message).gameName), this.screenProtocolScope);
		this.screenProtocol.AddReceiveMessageHandler(ScreenGameMenuMessage.msgname, (message) => this.GameExit(), this.screenProtocolScope);

		this.screenProtocol.Connect();
		//Add translation
		// this.translator = service.translator;

		this.multigameParams = {
			systemContext: this.systemContext,
			viewSize: this.viewSize,
			screenProtocol: this.screenProtocol,
			resid: this.resid,
			translator: service.translator,
			audio: this.audio,
			backendSettings: service.backendSettings

		};
		
		
		// when message is received
		// this.screenProtocol.AddReceiveMessageHandler(ScreenLanguageSelectedMessage.msgname, (message) => {
		// 	let m: ScreenLanguageSelectedMessage  = message as ScreenLanguageSelectedMessage;

		// 	// set new language
		// 	this.translator.ChangeLanguage(m.locality);
		// }, this.screenProtocolScope);

		// if (Settings.screen3Display == Screen3SettingDisplay.JackpotDisplay) {
		// 	let params: JackpotDisplayParams = {
		// 		systemContext: this.systemContext,
		// 		resid: this.resid,
		// 		viewSize: this.viewSize,
		// 		screenProtocol: this.screenProtocol
		// 	};

		// 	this.jackpotDisplay = this.JackpotDisplayFactory.CreateNewJackpotDisplay(params);
		// 	params = null;
		// 	globalThis.jackpotDisplayGlobal = this.jackpotDisplay;
		// 	this.jackpotDisplay.View().style.zIndex = ZIndex.JPType.toString();
		// } else if (Settings.screen3Display == Screen3SettingDisplay.GameTitleJackpot) {
		// 	let params: Screen3DisplayParams ={
		// 		systemContext: this.systemContext,
		// 		resid: this.resid,
		// 		viewSize: this.viewSize,
		// 		slotGames:this.slotGames,
		// 		//screenProtocol: this.screenProtocol
		// 	};
	
		// 	this.screen3Display = this.screen3DisplayFactory.CreateScreen3DisplayFactory(params);			
		// }

	
		
		
		this.screenProtocol.AddReceiveMessageHandler(AnimationStopRequest.msgname, (message) => {
			this.jackpotDisplay?.StopAnimations();
		}, this.screenProtocolScope);
//

		this.screenProtocol.AddReceiveMessageHandler(AnimationStartRequest.msgname, (message) => {
			this.jackpotDisplay?.StartAnimations();
		}, this.screenProtocolScope);

		this.screenProtocol.AddReceiveMessageHandler(JackpotValuesUpdate2.msgname, (message) => 
			this.OnJackpotValues((<JackpotValuesUpdate2>message).values), 
		this.screenProtocolScope);
	
		let gamesMenuParams : IGamesMenuParams = { 
			systemContext:this.systemContext,
			logGroup:this.logGroup, 
			resid:this.resid, 
			availableGames:this.availableGames, 
			viewSize:this.viewSize, 
			slotGames:this.slotGames as any as Map<string, SlotGame>, 
			translator: service.translator, 
			clientState:null, 
			audio:null,
			// CashierLogin: this.cashierLogin,
		
		}
		this.gamesMenu21 = this.menuFactory3.CreateGamesMenu3Screen(gamesMenuParams);
		gamesMenuParams = null;

		
		this.presentationCycleTimer = this.systemContext.TimingContext().CreateInterval(this.resid.Add("presentationCycleTimer").ID(), 11600, () => {
			this.ShowNextPresentation();
		});
		
	}
	OnResize(w: number, h: number, orientation: Orientation): void {
		throw new Error("Method not implemented.");
	}

	// // step 0 - machine info
	// public SetLoadInfo(machineInfo: LoadInfo) {
	// 	this.stateMachine.ChangeState(Multigame21State.Loading);

	// 	if (machineInfo.AvailableGames.length > 0)
	// 	{
	// 		for (let i = 0; i < machineInfo.AvailableGames.length; i++) {
	// 			let availableGame: AvailableGame = machineInfo.AvailableGames[i]

	// 			// Log.Debug(this.logGroup, "SetLoadInfo(availableGame=" + availableGame.Name + ")");
	// 			this.AddAvailableGame(availableGame);
	// 		}
	// 	}
	// 	else
	// 	{
	// 		this.LoadGames();
	// 	}
	// }

	// // step 1 - fill in all the games
	// public AddAvailableGame(availableGame: AvailableGame) {
	// 	// Log.Debug(this.logGroup, "AddAvailableGame(" + availableGame.Name + ")");
	// 	this.availableGames.set(availableGame.Name, availableGame);
	// }

	// // step 2 - data for each enabled games
	// public SetInitialData(initData: SlotGameInitData) {
	// 	// Log.Debug(this.logGroup, "SetInitialData(game=" + initData.Name + ")");

	// 	let availGame: AvailableGame = this.availableGames.get(initData.Name);

	// 	// TODO check if enabled
	// 	if (availGame /*&& availGame.enabled*/) {
	// 		this.initData.set(initData.Name, initData);
	// 	}
	// 	else {
	// 		Log.Error(this.logGroup, "Trying to construct game " + initData.Name + ", but it is not available");
	// 	}

	// 	if (this.initData.size == this.availableGames.size) {
	// 		this.LoadGames();
	// 	}
	// }

	protected GetGameEntryPoint(availableGame: AvailableGame): JSResource {
		return new JSResource(`./multigame/slot/${availableGame.Name}/game3.js`, availableGame.Name + ".js", this.view);
	}

    // steps 3, 4, 5
	//protected backendSettings: BackendSettings;
    public SetLoadInfo(loadInfo: LoadInfo, settings: SettingsNode, games: IGameConfiguration[]): void {

		//this.backendSettings = new BackendSettings(loadInfo.Settings as unknown as IBackendSettings);

		this.availableGames.clear();
		games.forEach(g => {
			if (g.GameType == GameType.Slot)
			{
				this.availableGames.set(g.GameName, {
					Enabled: true,
					Index: g.GameIndex,
					Name: g.GameName,
					Order: g.Order
				});
			}
		});


		this.initData.clear();
		games.forEach(g => {
			if (g.GameType == GameType.Slot)
			{
				this.initData.set(g.GameName, g as any as SlotGameInitData)
			}
		});

        this.availableGames.forEach((availableGame: AvailableGame, name: string) => {
            let initData = this.initData.get(name);
            if (!initData) {
                Log.Error(this.logGroup, `Game ${name} does not have init data!`);
                throw `Game ${name} does not have init data!`;
            }

            const game: SlotGame21 = this.ConstructGame(name, this.multigameParams, initData);
            this.slotGames.set(name, game);
        });

        // Log.Debug(this.logGroup, "All games were loaded");
        this.GamesLoaded();
        // this.LoadResources();
    }

	protected ConstructGame(name: string, multigameParams: MultigameParams21, initData: SlotGameInitData): SlotGame21 {
		const gameFactory: IGameFactory = CreateGameFactory.Instance.GetFactory(name);
		const game: SlotGame21 = gameFactory.CreateGame21(multigameParams, initData);

		return game;
	}

	

	// // step 3 - load initial game class for all games 
	// public LoadGames(): void {
	// 	// Log.Debug(this.logGroup, "LoadGames()");

	// 	if (this.availableGames.size > 0) {

	// 		// Log.Debug(this.logGroup, "Loading games");

	// 		this.availableGames.forEach((availableGame: AvailableGame, name: string) => {
	// 			// Log.Debug(this.logGroup, "LoadGames(name=" + name + ")");

	// 			let game: JSResource = this.GetGameEntryPoint(availableGame); //new JSResource(availableGame.path, availableGame.name + ".js", this.view);
	// 			game.AddOnLoadedCallback(() => this.GameLoaded(name));
	// 			game.AddOnLoadErrorCallback(() => {
	// 				Log.Error(this.logGroup, "Error loading game " + name + " from " + game.path);
	// 			});

	// 			game.Load();
	// 		});
	// 	}
	// 	else {
	// 		Log.Error(this.logGroup, "No games to load");
	// 	}
	// }

	// // step 4
	// private GameLoaded(name: string) {
	// 	//// Log.Debug(this.logGroup, "GameLoaded()");

	// 	// Log.Debug(this.logGroup, "GameLoaded(" + name + ")");

	// 	let game: SlotGame3 = this.ConstructGame(name);
	// 	if (game)
	// 	{
	// 		this.slotGames.set(name, game);
	// 		//this.slotGamesByIndex.set(game.index, game);

	// 		//this.view.appendChild(game.View());
	// 	}

	// 	this.gamesLoaded++;

	// 	// Log.Debug(this.logGroup, "Loaded game " + this.gamesLoaded + "/" + this.availableGames.size);

	// 	if (this.gamesLoaded == this.availableGames.size) {
	// 		// all games were loaded
	// 		// Log.Debug(this.logGroup, "All games were loaded");
	// 		this.GamesLoaded();
	// 		this.LoadResources();
	// 	}
	// }

	// // step 5
	// private ConstructGame(name: string): SlotGame3 {

	// 	// if game not yet constructed and all data available, construct new game
	// 	let classname: string = name + "3";
	// 	let namespaceName = "SlotGames3"
	// 	let namespace: any = <any>(window[namespaceName]);

	// 	let gameclass: any = namespace[classname];
	// 	if (!gameclass) {
	// 		Log.Error(this.logGroup, "Game class " + classname + " for game " + name + " does not exist in namespace " + namespaceName, namespace);
	// 		return null;
	// 	}

	// 	let initData = this.initData.get(name);
	// 	if (!initData) {
	// 		Log.Error(this.logGroup, "Game " + classname + " does not have init data!");
	// 		return null;
	// 	}

	// 	let game: SlotGame3 = new gameclass(this.multigameParams, initData);
	// 	// Log.Debug(this.logGroup, "Game " + game.name + " constructed successfully");

	// 	return game;
	// }

	// step 6
	//protected LoadResources() {
	public async PrepareResources(loadingStage: LoadingStage, resourceManager: IWriteOnlyResourceManager): Promise<void> {
		// if (loadingStage == LoadingStage.System) {
		// 	await this.PrepareResourcesSystem(loadingStage, resourceManager);						
		// 	// preapre resources for jackpot display
		// 	await this.jackpotDisplay?.PrepareResources(loadingStage, resourceManager);
		// }

		// if (loadingStage == LoadingStage.Games)
		// 	await this.PrepareResourcesGames(loadingStage, resourceManager);

		if (loadingStage == LoadingStage.System)
			await this.PrepareResourcesSystem(loadingStage,resourceManager);

		if (loadingStage == LoadingStage.GamesPreload)
			await this.PrepareResourcesGames(loadingStage, resourceManager);

		if (loadingStage == LoadingStage.Games)
			await this.PrepareResourcesGames(loadingStage, resourceManager);

		
	}

	protected async PrepareResourcesSystem(loadingStage: LoadingStage, resourceManager: IWriteOnlyResourceManager): Promise<void>
	{
		resourceManager.Add(new CSSResource(this.basepath + "multigame.2.css", this.resid.ScopedResourceName() + "css", "." + this.resid));
		resourceManager.Add(new ImageResource(this.basepath + "img/preview-frame.png", this.resid.ScopedResourceName() + "image"));

		// Log.Debug(this.logGroup, "Loading resources started");


		//resourceManager.Add(new CSSResource(this.basepath + "multigame.3.css", this.resid.ScopedResourceName() + "css", "." + this.resid));
        //resourceManager.Add(new HTMLResource(this.basepath + "multigame.3.html", this.resid.ScopedResourceName() + "html"));
        
		//if(Settings.Branding == Branding.Ortiz){
        // this is the background for when theres no game selected, when we're in menu
        //this.resourceManager.Add(new ImageResource(this.basepath + "img/background.3.png", this.resid.ScopedResourceName() + "background"));
		//}

        //Se agrega la imagen 
		//this.resourceManager.Add(new ImageResource(this.jackpot2 + "background.3.1.png", this.resid.ScopedResourceName("background2")));

		// prepare resources of all games


		resourceManager.WithLogging(() => {			
			// // preapre resources for jackpot display
			// this.jackpotDisplay?.PrepareResources(loadingStage, resourceManager);
			//prepare resources for 3Screen Game title Display 
			// this.screen3Display?.PrepareResources(resourceManager);
		});

		let notoSansDisplay: any = [
        	{fileName: "NotoSansDisplay-Black", fontName: "Default-Black"},
			{fileName: "NotoSansDisplay-BlackItalic", fontName: "Default-BlackItalic"},
			{fileName: "NotoSansDisplay-Bold", fontName: "Default-Bold"},
			{fileName: "NotoSansDisplay-BoldItalic", fontName: "Default-BoldItalic"},
			{fileName: "NotoSansDisplay-ExtraBold", fontName: "Default-ExtraBold"},
			{fileName: "NotoSansDisplay-ExtraBoldItalic", fontName: "Default-ExtraBoldItalic"},
			{fileName: "NotoSansDisplay-ExtraLight", fontName: "Default-ExtraLight"},
			{fileName: "NotoSansDisplay-ExtraLightItalic", fontName: "Default-ExtraLightItalic"},
			{fileName: "NotoSansDisplay-Italic", fontName: "Default-Italic"},
			{fileName: "NotoSansDisplay-Light", fontName: "Default-Light"},
			{fileName: "NotoSansDisplay-LightItalic", fontName: "Default-LightItalic"},
			{fileName: "NotoSansDisplay-Medium", fontName: "Default-Medium"},
			{fileName: "NotoSansDisplay-MediumItalic", fontName: "Default-MediumItalic"},
			{fileName: "NotoSansDisplay-Regular", fontName: "Default-Regular"},
			{fileName: "NotoSansDisplay-SemiBold", fontName: "Default-SemiBold"},
			{fileName: "NotoSansDisplay-SemiBoldItalic", fontName: "Default-SemiBoldItalic"},
			{fileName: "NotoSansDisplay-Thin", fontName: "Default-Thin"},
			{fileName: "NotoSansDisplay-ThinItalic", fontName: "Default-ThinItalic"}
        ];

        for (let i = 0; i < notoSansDisplay.length; i++) {
        	resourceManager.AddGlobal(new FontResource(this.basepath + "fonts/Noto/NotoSansDisplay-normal/" + notoSansDisplay[i].fileName + ".ttf", notoSansDisplay[i].fileName));
        }

		// set default font before loading others
		let defFontStyle: HTMLElement = document.createElement("style");
		defFontStyle.innerHTML = "body {font-family: 'NotoSansDisplay-Regular', sans-serif}";
		document.querySelector("head").appendChild(defFontStyle);
		defFontStyle = null;
	
		//this.resourceManager.Finished();
		//this.resourceManager.ReadyToLoad();

		this.PreparePresentationJackpotDisplay(resourceManager);
			
		this.gamesMenu21.PrepareResources(resourceManager);


        //GlobalLoadCoordinator.Instance.ScreenReadyToLoad("Screen3");
	}

	protected async PrepareResourcesGames(loadingStage: LoadingStage, resourceManager: IWriteOnlyResourceManager): Promise<void>
	{
		// for (let [gameName, game] of this.slotGames)
		// {
		// 	resourceManager.SetCurrentGame(gameName);
		// 	await game.PrepareResources(loadingStage, resourceManager);
		// 	resourceManager.SetCurrentGame(null);
		// }
		if (loadingStage == LoadingStage.GamesPreload)
			{
				for (let [name, game] of this.slotGames)
				{
					resourceManager.SetCurrentGame(name);
					await game.PrepareResources(loadingStage, resourceManager);
					this.audio.GetNewResources().forEach(r => resourceManager.Add(r));
					resourceManager.SetCurrentGame(null);
				};
			}
	
			if (loadingStage == LoadingStage.Games)
			{
				for (let [name, game] of this.slotGames)
				{
					resourceManager.SetCurrentGame(name);
	
					await game.PrepareResources(loadingStage, resourceManager);
					if (game.HasPresentation())
					{
						resourceManager.AddGlobal(new PixiSpriteResource(`${Settings.ResourcesFolder}multigame/slot/${game.name}/resources/title_sprite2`, ResourceIdentifier.Global.Add(name).Add("title"), true, this.logGroup.Add(name).Add("title"), true));
					}
					this.audio.GetNewResources().forEach(r => resourceManager.Add(r));
					resourceManager.SetCurrentGame(null);
				};
				if (Settings.JackpotDisplayType != JackpotDisplayType.PaytableJackpotDisplay){
					//resourceManager.Add(new SpriteResource(game.basepath + "resources/title_sprite", this.resid.Add("title"), true, this.logGroup.Add("title"), true));
					resourceManager.AddGlobal(new SpriteResource(`${Settings.ResourcesFolder}multigame/multigame/img/JackpotsResources-Slider/`+Settings.JackpotDisplayType+"/titleJackpotDisplay", ResourceIdentifier.Global.Add(Settings.JackpotDisplayType).Add("presentation-title"), true, this.logGroup.Add(Settings.JackpotDisplayType).Add("presentation-title"), true));
				}	
			}

	}

	// step 7
	public LoadProgress(percent: number) {
		this.loadingContainer.innerHTML = "Loading... " + Math.round(percent) + "%";
	}
	
	protected malfunction:HTMLElement = null;
	protected serialNumberElement:HTMLElement = null;

	public async ResourcesLoaded(loadingStage: LoadingStage, resourceManager: IReadOnlyResourceManager): Promise<void> {
		if (loadingStage == LoadingStage.System) {
			await this.ResourcesLoadedSystem(loadingStage, resourceManager);
			await this.jackpotDisplay?.ResourcesLoaded(loadingStage, resourceManager);
			if (this.jackpotDisplay != null) this.view.appendChild(this.jackpotDisplay.View());
		}
		else if (loadingStage == LoadingStage.Games) {
			await this.ResourcesLoadedGames(loadingStage, resourceManager);
		}
		// else if (loadingStage == LoadingStage.GamesPreload) {
		// 
		// }
		else if (loadingStage == LoadingStage.Finished)
			{
				await this.ResourcesLoadedFinished(loadingStage, resourceManager);
				this.StartPresentation();
			}

		
	}

	public async LoadFinishedSuccess()
	{
		
	}

	public async LoadFailed(loadingStage: LoadingStage, resources: Resource[]): Promise<void>
	{
	}
	
	public async ResourcesLoadedSystem(loadingStage: LoadingStage, resourceManager: IReadOnlyResourceManager): Promise<void>
	{

		// Log.Debug(this.logGroup, "Loading resources finished");

        //this.view.innerHTML += resourceManager.Get<HTMLResource>(this.resid.ScopedResourceName() + "html").html;
        //console.log("Inner html of view is: " + this.view.innerHTML);
        //debugger;
        //this.view.style.backgroundImage = this.resourceManager.Get<ImageResource>(this.resid.ScopedResourceName() + "background").CssBackground();
        //this.view.style.backgroundImage = this.resourceManager.Get<ImageResource>(this.resid.ScopedResourceName("background2"))
        this.view.style.backgroundSize = "cover";

        
        this.gamesMenuContainer = CreateElement("div", {
			classes: ["gamesmenu"],
			parentToAppend: this.view,
		});

		this.gamesContainer = CreateElement("div", {
			classes: ["games"],
			parentToAppend: this.view
		});

        //jackpot
		//this.view.appendChild(this.jackpotContainer2);
		
		this.malfunction = CreateElement("div", {
			classes: ["malfunction"],
			style: {
				position:"absolute",
				top:"0px",
				left:Scale.Xpx(1139),
				width: Scale.Wpx(768),
				height:Scale.Hpx(55),
				fontFamily:"NotoSansDisplay-BoldItalic",
				fontSize: Scale.fhpx(23),
				color:"white",
				//zIndex:"10000",
				zIndex: ""+ ZIndex.Malfunction,
				textShadow:`0px 0px ${Scale.XY(10)}px black, 0px 0px ${Scale.XY(20)}px black, 0px 0px ${Scale.XY(30)}px black`,
				textAlign:"right",
			}
		});

		//SerialNumber
		this.serialNumberElement = CreateElement("div", {
			classes:["serialnumber"],
			style: {
				position:"absolute",
				top:"0px",
				left:Scale.Xpx(10),
				width: Scale.Wpx(768),
				height:Scale.Hpx(55),
				fontFamily:"NotoSansDisplay-BoldItalic",
				fontSize: Scale.fhpx(23),
				color:"white",
				//zIndex:"10000",
				zIndex: ""+ ZIndex.Malfunction,
				textShadow:`0px 0px ${Scale.XY(10)}px black, 0px 0px ${Scale.XY(20)}px black, 0px 0px ${Scale.XY(30)}px black`,
				textAlign:"left",
			}
		});

		 //Append menu
		 this.gamesMenu21.ResourcesLoaded(resourceManager);
		 this.view.appendChild(this.gamesMenu21.View());
		 this.gamesMenu21.Show();
 

		if (Settings.ScreenConfiguration == ScreenConfiguration.CombinedScreen) {
			this.view.appendChild(this.malfunction);
			this.view.appendChild(this.serialNumberElement);
		}

		if (service.backendSettings.GetString("play.malfunctionmessage","malfunction").toLowerCase() == "malfunction"){
			this.malfunction.appendChild(service.translator.Anchor(() => service.translator.t.mailfuncion));
		} else {
			this.malfunction.appendChild(service.translator.Anchor(() => service.translator.t.amusement));
		}
		//this.serialNumberElement.innerHTML = "11022210051";
		this.UpdateSerialNumber();

		this.gamesMenu21.ResourcesLoaded(resourceManager);
		this.gamesMenu21.View().style.zIndex = ZIndex.ElementsMenu.toString();
		this.view.appendChild(this.gamesMenu21.View());
		this.gamesMenu21.Show();

		this.LoadPresentationJackpotDisplay(resourceManager);
		this.LoadedTitleClassicGamesJackpotDisplay(resourceManager);
	
		// append jackpot display
		// because we append JackpotDisplay the latest, it will be on top of everything else
		//add new feature for hide jackpot and gameTitleJackpot on screen 3 

		// resourceManager.WithLogging(() => {		
		// 	if (this.screen3Display)
		// 	{
		// 		//this.jackpotDisplay?.ResourcesLoaded(loadingStage, resourceManager);
		// 		this.screen3Display.ResourcesLoaded(resourceManager);
		// 		this.view.appendChild(this.screen3Display?.View());
		// 	}
		// });

		this.stateMachine.ChangeState(Multigame21State.Running);
		this.TryApplyMultigameSession();


		//loaded resources for games menu

		// append title
		this.view.appendChild(this.divtitle);
		// append video
		 this.view.appendChild(this.div);
		
		//MENU FACTORY LOAD
		// await this.gamesMenu21.ResourcesLoaded(resourceManager);
		// this.gamesMenu21.View().style.zIndex = ZIndex.ElementsMenu.toString();
		// this.view.appendChild(this.gamesMenu21.View());
		// this.gamesMenu21.Show();
		// this.screen3Display?.GameTitleAnim("ClassicMix");

		// if (this.jackpotValuesBuffer != null) {
		// 	this.OnJackpotValues(this.jackpotValuesBuffer);
		// }

	}
	protected gamePresentation: GamePresentation21=null;
	protected gamePresentations: IGamePresentation[] = [];

	protected StartPresentation(): void {
		
		if (this.gamePresentations.length > 0)
		{
			// show random presentation right now
			this.ShowFirstPresentation();

			// cycle trough presentations
			this.presentationCycleTimer.Start();
		}
		// else{
		// 	// no presentations to run
		// }
	}
	protected currentGamePresentationIndex: number = -1;
	protected presentationCycleTimer: IInterval = null;

	protected ShowNextPresentation()
	{
		this.gamePresentations[this.currentGamePresentationIndex].Hide();
		this.currentGamePresentationIndex = (this.currentGamePresentationIndex +1) % this.gamePresentations.length;
		this.gamePresentations[this.currentGamePresentationIndex].Show();
	}

	protected ShowFirstPresentation()
	{
		this.currentGamePresentationIndex = (this.currentGamePresentationIndex +1) % this.gamePresentations.length;
		this.gamePresentations[this.currentGamePresentationIndex].Show();
	}

	protected StopPresentation(): void {
		if (this.gamePresentations.length > 0)
		{
			// stop presentations timer
			this.presentationCycleTimer.Stop();
			
			this.HideCurrentPresentation();

			this.div.style.visibility = "hidden";
		}
		else
		{
			// no presentations
		}
	}

	protected HideCurrentPresentation()
	{
		// hide current presentation
		this.gamePresentations[this.currentGamePresentationIndex].Hide();
	}


	public async ResourcesLoadedGames(loadingStage: LoadingStage, resourceManager: IReadOnlyResourceManager): Promise<void>
	{
		//this.jackpotDisplay.ResourcesLoaded(loadingStage, resourceManager);		
		// notify all games
		// for (let [name, game] of this.slotGames)
		// {
		// 	resourceManager.SetCurrentGame(name);
		// 	await game.ResourcesLoaded(loadingStage, resourceManager);
		// 	resourceManager.SetCurrentGame(null);

		// 	let view: HTMLElement = game.View();
		// 	view.classList.add("game");
		// 	view.style.position = "relative";
		// 	//view.style.top = "0px";
		// 	//view.style.left = "0px";
		// 	view.style.display = "none";


		// 	this.gamesContainer.appendChild(view);
		// }

		if (loadingStage == LoadingStage.GamesPreload)
		{
			for (let [name, game] of this.slotGames)
			{
				resourceManager.SetCurrentGame(name);
				await game.ResourcesLoaded(loadingStage, resourceManager);
				resourceManager.SetCurrentGame(null);
			};
			

			return;
		}

		if (loadingStage == LoadingStage.Games)
		{
			// notify all games
			for (let [name, game] of this.slotGames)
			{
				await game.ResourcesLoaded(loadingStage, resourceManager);

				let view: HTMLElement = game.View();
				view.classList.add("game");
				view.style.position = "relative";
				view.style.display = "none";

				
				this.gamesContainer.appendChild(view)

				// take presentation from game for when we're in menu
				// if (Settings.Screens != 3 && Settings.JackpotDisplayType != JackpotDisplayType.PaytableJackpotDisplay)
				// {
				// 	continue;
				// }

				//USE FOR 3 SCREEN
				// if (!game.HasPresentation())
				// {
				// 	continue;
				// }

				// here all images/jsons are loaded, let's create them
				let sprite: ISprite = resourceManager.Get<PixiSpriteResource>(ResourceIdentifier.Global.Add(game.name).Add("title")).sprite;
				let canvasSprite: CanvasSprite = new CanvasSprite({sprite: sprite, canvasSize: new Size(Scale.W(1920), Scale.H(1080))});

				// fix to look the old way, tretched out
					//canvasSprite.ScaleNonUniform(1.05, 1);
	
	
	
					canvasSprite.View().style.position = "absolute";
					canvasSprite.View().style.position = "center";
					canvasSprite.View().style.alignContent = "center";
					canvasSprite.View().setAttribute("id", game.name);
					canvasSprite.View().style.justifyContent = "center";
					canvasSprite.View().style.position = "absolute";
					//canvasSprite.View().style.top="-100px";
	
	
					// hidden by default
					canvasSprite.View().style.visibility = "hidden";
	
	
	
	
	
					// game presentation is title + video
					this.gamePresentation = new GamePresentation21(canvasSprite);
					this.gamePresentations.push(this.gamePresentation);
					// finally append to divtitle container div
					this.divtitle.appendChild(canvasSprite.View());
					canvasSprite = null;
					sprite = null;
				};


		}
	}

	protected PreparePresentationJackpotDisplay(resourceManager: IWriteOnlyResourceManager)
	{
		if (Settings.JackpotDisplayType == JackpotDisplayType.PaytableJackpotDisplay)
		{
			return;
		}

		resourceManager.AddGlobal(new SpriteResource(`${Settings.ResourcesFolder}multigame/multigame/img/JackpotsResources-Slider/`+Settings.JackpotDisplayType+"/titleJackpotDisplay", ResourceIdentifier.Global.Add(Settings.JackpotDisplayType).Add("presentation-title"), true, this.logGroup.Add(Settings.JackpotDisplayType).Add("presentation-title"), true));	
	}

	protected LoadPresentationJackpotDisplay(resourceManager: IReadOnlyResourceManager)
	{
		if (Settings.JackpotDisplayType == JackpotDisplayType.PaytableJackpotDisplay)
		{
			return;
		}

		// here images/jsons are loaded, let's create them
		let sprite: ISprite = resourceManager.Get<SpriteResource>(ResourceIdentifier.Global.Add(Settings.JackpotDisplayType).Add("presentation-title")).sprite;
		let canvasSprite: CanvasSprite = new CanvasSprite({sprite: sprite, canvasSize: new Size(Scale.W(1920), Scale.H(1080)), drawFirstFrame: true, sizing: CanvasSpriteSizing.Fit, createElementParams: {
			style: { 
				position: "absolute",
				alignContent: "center",
				justifyContent: "center",					
				// hidden by default
				visibility: "hidden",
			}
		}});
		sprite = null

		// game presentation is title + video
		this.gamePresentation = new GamePresentation21(canvasSprite);
		this.gamePresentations.push(this.gamePresentation);
		
		
		// finally append to divtitle container div
		this.divtitle.appendChild(canvasSprite.View());
		canvasSprite = null;
	}


	protected LoadedTitleClassicGamesJackpotDisplay(resourceManager: IReadOnlyResourceManager)
	{
		if (Settings.JackpotDisplayType == JackpotDisplayType.PaytableJackpotDisplay )
		{
			// here images/jsons are loaded, let's create them
			let sprite: ISprite = resourceManager.Get<SpriteResource>(ResourceIdentifier.Global.Add(Settings.JackpotDisplayType).Add("presentation-title")).sprite;
			let canvasSprite: CanvasSprite = new CanvasSprite({sprite: sprite, canvasSize: new Size(Scale.W(1920), Scale.H(1080)), drawFirstFrame: true, sizing: CanvasSpriteSizing.Fit, createElementParams: {
				style: { 
					position: "absolute",
					alignContent: "center",
					justifyContent: "center",					
					// hidden by default
					visibility: "hidden",
				}
			}});
			sprite = null;

			// game presentation is title + video
			this.gamePresentation = new GamePresentation21(canvasSprite);
			this.gamePresentations.push(this.gamePresentation);
			
			// finally append to divtitle container div
			this.divtitle.appendChild(canvasSprite.View());
		}
	}

	public async ResourcesLoadedFinished(loadingStage: LoadingStage, resourceManager: IReadOnlyResourceManager): Promise<void>
	{
		this.loadingContainer.style.display = "none";		
	}

	public View(): HTMLElement
	{
		return this.view;
	}

	public Update(): void {		
		if (this.stateMachine.State() == Multigame21State.Running) {
			if (this.selectedGame) {
				this.selectedGame.Update();
			}					
			// this.screen3Display?.Update();			
			this.jackpotDisplay?.Update();	
		}
		if (this.currentGamePresentationIndex != -1)
			{
				this.gamePresentations[this.currentGamePresentationIndex].Update();
			}		
	}

	/**************************************************************************
		EVENTS
	**************************************************************************/
	private gamesLoadedCallbacks: MultigameGamesLoadedCallback[] = [];
	public OnGamesLoaded(callback: MultigameGamesLoadedCallback): void {
		this.gamesLoadedCallbacks.push(callback);
	}

	private GamesLoaded() {
		for (let i: number = 0; i < this.gamesLoadedCallbacks.length; i++) {
			this.gamesLoadedCallbacks[i]();
		}
	}

	private resourcesLoadedCallbacks: MultigameResourcesLoadedCallback[] = [];
	public OnResourcesLoaded(callback: MultigameResourcesLoadedCallback): void {
		this.resourcesLoadedCallbacks.push(callback);
	}

	private TriggerResourcesLoaded() {
		for (let i: number = 0; i < this.resourcesLoadedCallbacks.length; i++) {
			this.resourcesLoadedCallbacks[i]();
		}
	}

	public SelectGameInMenu(gameName: string): void {
		this.session.selectedGameNameInMenu = gameName;
	}
	
	protected ShowGame(gameName: string):void 
	{
		this.StopPresentation();
		let selectedGame = this.slotGames.get(gameName);
		if (selectedGame)
		{
			/* 
			this.session.selectedGameIndex = index;
			this.selectedGame = selectedGame

			this.selectedGame.GameSelected();

			this.selectedGame.View().style.display = "block";

			// show games, hide menu
			try
			{
				this.gamesMenuContainer.style.visibility = "hidden";
				this.gamesContainer.style.display = "block";
			}
			catch (ex)
			{

			}
			*/
			this.gamesMenu21.Hide();
			this.session.selectedGameName = gameName;
			this.selectedGame = selectedGame

			this.selectedGame.GameSelected();

			//MENU HIDE
			this.gamesMenu21.Hide();
			this.selectedGame.View().style.display = "block";

			// show games, hide menu
			try
			{
				this.gamesMenuContainer.style.visibility = "hidden";
				this.gamesContainer.style.display = "block";
			}
			catch (ex)
			{

			}
		}
		else 
		{
			Log.Error(this.logGroup, `Game  ${gameName} does not exist`);
		}
	}

	public GameSelected(gameName: string): void {
        let selectedGame = this.slotGames.get(gameName);
		if (selectedGame) {

			this.HideAllGames();
			this.ShowGame(gameName);
			this.gamesMenu21.Hide();

			// this.screen3Display?.GameTitleAnim(gameName);
			


			/* this.session.selectedGameIndex = index;
			this.selectedGame = selectedGame

			this.selectedGame.GameSelected();

			this.selectedGame.View().style.display = "block";

			// show games, hide menu
			try
			{
				this.gamesMenuContainer.style.visibility = "hidden";
				this.gamesContainer.style.display = "block";
			}
			catch (ex)
			{

			} */
			selectedGame = null;
		}
		else {
			Log.Error(this.logGroup, `Game ${gameName} does not exist`);
		}
	}

    public GameExit(): void
    {
        if (this.selectedGame != null) {
        	this.selectedGame.GameExit();
			if (Settings.MenuType == MenuType.InGameMenu)
			{
				this.GameExitOneGame();
				return;
			}
            this.selectedGame.View().style.display = "none";
            // show menu, hide game
            this.gamesMenuContainer.style.visibility = "visible";
            this.gamesContainer.style.display = "none";
			this.gamesMenu21.Show();
			//hide screen3Display canvas
			// this.screen3Display?.GameExit(this.selectedGame.name);
			this.session.selectedGameName = null;
            this.selectedGame = null;
			// this.screen3Display?.GameTitleAnim("ClassicMix");
			this.StartPresentation();
        }
    }

	protected HideAllGames()
	{
		if (Settings.MenuType != MenuType.InGameMenu)
			{
				return;
			}
		
		for (let [name, game] of this.slotGames)
			{
				game.View().style.display = "none";
			}
					
	}

	public GameExitOneGame()
	{
		this.HideAllGames();
		this.selectedGame.View().style.display = "block";
	}

	/**************************************************************************
		SCREEN PROTOCOL HANDLING
	**************************************************************************/
    protected  OtherScreenIntroduction(message: ScreenIntroductionMessage): void {
		if (message.from == "1" && message.to == "*") {
		}
	}

	protected MainScreenReloadRequest(): void {
		//this.Reload();
	}

	protected MainScreenConnectionLost(): void {
		// this.view.style.display = "flex";
		// this.view.classList.add("center-center");

		// this.view.innerHTML = "Connection to main screen lost";
	}

	protected MainScreenConnectionRestored(): void {
		// this.view.innerHTML = "Connection to main restored";
		// this.Reload();
	}

	// protected Reload(): void {
	// 	// window.location.reload();
	// }

	protected OnMultigameSync(message: ScreenMultigameSyncMessage): void {

		// Log.Debug(this.logGroup, "Multigame sync: " + JSON.stringify(message));

		this.tmpSession = new Multigame21Session();
		this.tmpSession.selectedGameName = message.selectedGameName;
		this.tmpSession.selectedGameNameInMenu = message.selectedGameNameInMenu;

		this.TryApplyMultigameSession();
	}

	protected TryApplyMultigameSession(): void {
		if (this.stateMachine.State() == Multigame21State.Running && this.tmpSession != null) {

			// Log.Debug(this.logGroup, "Applying multigame session");

			this.SelectGameInMenu(this.tmpSession.selectedGameNameInMenu);

			if (this.tmpSession.selectedGameName != null) 
			{
				this.GameSelected(this.tmpSession.selectedGameName);
			}

			this.tmpSession = null;
		}
	}

	protected jackpotValuesBuffer: JackpotValue2[] = null;

	protected OnJackpotValues(jackpotValues: JackpotValue2[])
	{
		if (this.stateMachine.State() == Multigame21State.Running)
		{
			this.jackpotDisplay?.UpdateValues(jackpotValues);
		}
		else
		{
			this.jackpotValuesBuffer = jackpotValues;
		}
	}

	public ViewReady(): void {}

	public OnButtonChanged(button: Button, pressed: boolean)
	{
	}
	public BackgroundView(): HTMLElement {
		return null
	}
}
